<template>
  <p class="mail-field" :class="{ 'control': true }">
    <input autocomplete="off" class="mail-field__input" type="email"
           :required="data.required"
           v-validate="data.validationRule"
           :class="{'input': true, 'is-danger': errors.has('email') }"
           :id="data.id"
           :name="data.id"
           :placeholder="data.placeholder">
    <span v-show="errors.has('email')" class="mail-field__error-message">{{ errors.first('email') }}</span>
    <label class="mail-field__label" :for="data.id">
      {{data.label}}
    </label>
  </p>
</template>

<script>
export default {
  name: 'EmailField',
  props: {
    data: Object
  }
}
</script>

<style lang="scss">
  .mail-field {
    position: relative;
    display: flex;
    margin: 0;
    max-width: 390px;
    justify-content: flex-end;
    align-items: center;

    &__input {
      display: block;
      width: 300px;
      padding: 11.4px 12px 9px 8.4px;
      border: 1px solid #ebedf2;
      border-radius: 3px;
      transition: 250ms ease-in;
      box-sizing: border-box;
      letter-spacing: 0.2px;

      &:focus {
        outline: 0;
        border-color: #554dbd;
      }

      ::placeholder {
        opacity: 1;
        color: #999999;
      }
    }

    &__error-message {
      position: absolute;
      bottom: -22px;
      font-size: 14px;
      font-weight: 300;
      line-height: 21px;
      color: #f4516c;
      width: 300px;
    }

    &__label {
      order: -1;
      margin-right: 20px;
      font-size: 14px;
      line-height: 21px;
      color: #333333;
    }
  }
</style>
